<template>
  <span
    ref="parent"
    class="dropdown"
    style="position: relative"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <Toggle class="dropdown-toggle" :open="open" @toggle="toggle">
      <template #header>
        <slot :value="internalValue" name="header">{{ internalValue }}</slot>
      </template>
      <template #content>
        <div ref="content" v-click-outside="close" class="dropdown-content">
          <slot name="content" :set-value="setValue" :close="close" />
        </div>
      </template>
    </Toggle>
  </span>
</template>

<script>
import Toggle from '~/components/toggle'

export default {
  name: 'DropDown',
  components: { Toggle },
  props: {
    modelValue: {
      required: false
    },
    hover: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      open: false,
      internalValue: this.modelValue
    }
  },
  updated() {
    if (this.open && this.$refs.content) {
      // Trigger this event for parents element that need to programatically positionioned
      this.$emit('open', this.$refs)
    }
  },
  methods: {
    setValue(value) {
      this.internalValue = value
      this.$emit('update:modelValue', value)
    },
    close() {
      this.open = false
    },
    toggle(value) {
      this.open = value
    },
    mouseenter() {
      if (this.hover) {
        this.open = true
      }
    },
    mouseleave() {
      if (this.hover) {
        this.open = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.dropdown-toggle
  width: 100%

.dropdown-content
  position: relative
</style>
